import {
  REFRESH_CATEGORIES,
	SET_CATEGORIES,
} from './types';

export const setRefreshCategories = () => {
	return {
    type: REFRESH_CATEGORIES,
    payload: [],
  };
}

export const setCategories = (params) => {
	return {
    type: SET_CATEGORIES,
    payload: params,
  };
}